export const codetableAdministrationTranslation = {

  // menu
  codetable_administration: 8268,

  // codetable list
  add_new: 6943,
  add_child: 6943,
  add_sibling: 8383,
  delete: 7915,
  loading: 4501,
  search_hits: 7474,
  search_no_hits: 8309,
  no_access_to_codetable_administration: 8320,
  no_access_has_been_granted: 8156,
  no_codetable: 8381,
  no_code: 8382,
  no_category: 8404,
  hide_inactive_codes_filter: 8582,
  likelihood_description: 8446,
  recurrence_description: 8447,
  severity_description: 8448,
  likelihood: 6564,
  severity: 4506,
  severity_node: 9104,
  requrence_frequency: 8787,
  uom: 7207,
  unit_of_measure: 6132,
  consequence_type: 4736,
  low: 8436,
  middle: 8437,
  high: 8438,
  recurrence: 8439,
  interaction_option: 8484,
  interaction: 8485,
  consequences_severity_scalar_values_info: 8487,
  consequences_recurrence_scalar_values_info: 8488,
  consequences_likelihood_scalar_values_info: 8489,
  recurrence_frequency_scalar_values_info: 8789,
  likelihood_scalar_values_info: 8790,
  reference_option: 8526,
  update_code_parent: 9349,
  update_code_parent_info: 9370,
  update_code_parent_error: 9352,
  regenerate_aggregated_tables: 9428,

  // codetable item header
  update_code: 8269,
  add_code: 8308,
  cancel: 3273,
  delete_code_item_title: 8350,
  delete_confirm: 8351,
  delete_with_descendants_confirm: 8355,
  code_item_successfully_deleted: 8352,
  new_code_item: 8363,
  duplicate_code_item: 8425,

  // codetable item
  label: 8268,
  cancel_changes_title: 7558,
  cancel_changes_button: 3273,
  are_you_sure: 7460,
  undo_all: 5792,
  select_all: 8420,
  clear_all: 8421,
  go_back: 7966,
  translations_header: 8364,
  copy: 7842,
  copy_description_to_all: 8386,
  copy_long_description_to_all: 8387,
  copied_description_to_all: 8388,
  copied_long_description_to_all: 8389,
  descriptions_and_translations: 8391,
  show_translations: 8393,
  validation_error: 8206,
  details: 8044,
  visibility: 8394,
  switch_to_scroll: 7977,
  switch_to_tab: 7978,
  duplicate_code: 8426,
  checked_code: 8514,
  unchecked_code: 8515,
  uom_sets: 8535,
  uom_details: 8536,
  uom_measurement_system: 8701,
  uom_set_indicator: 8545,
  uom_set_substance: 8546,
  uom_sets_add_dropdown_label: 8547,
  uom_sets_add_label: 8548,
  uom_sets_substance_category_link: 8549,
  uom_sets_substance_hierarchy_link: 8550,
  uom_sets_substance_links: 8551,
  uom_sets_substance_links_info_text_1: 8554,
  uom_sets_substance_links_info_text_2: 8555,
  uom_conversion_factor_error: 8705,
  uom_conversion_factor_placeholder: 8711,
  uom_conversion_factor_info: 8716,
  uom_conversion_factor_info_default: 8786,
  uom_conversion_factor_info_readonly: 8777,
  uom_conversion_factor_missing_conversion: 8712,
  uom_conversion_factor_wrong_factor: 8717,

  merge_code_title: 8350,
  merge_code_subtitle: 9326,
  merge_code_replace_info: 9327,
  merge_code_violation_error: 9329,
  include_disabled: 9330, 

  // codetable item form
  code: 5483,
  disabled: 5251,
  sequence: 6825,
  parent_code: 8270,
  list_code: 8271,
  category: 6900,
  visible_for_case_types: 8396,
  visible_for_user_groups: 8395,
  visible_for_fields: 8004,
  description: 7278,
  long_description: 4326,
  same_for_all_languages_confirmation_box: 8290,
  switch_to_translated_per_language: 8291,
  translated_per_language_confirmation_box: 8292,
  switch_to_same_for_all_languages: 8293,
  same_for_all_languages: 8294,
  translated_per_language: 8295,
  must_be_filled_out: 5949,
  types: 8403,
  icon: 8416,
  icon_description: 8417,
  icon_format: 8418,
  colour: 8419,
  score_calc_weight: 8407,
  company_register_id: 3688,
  must_be_within_range: 7939,
  selected_value_disabled: 8453,
  page_of: 8454,
  scalar_values: 8483,
  min_level: 8486,
  reference_type: 8490,
  reference: 7940,
  recurrence_level: 8520,
  severity_level: 8518,
  likelihood_level: 8519,
  default_uom: 8522,
  default_uom_type: 8523,
  manage_options: 8521,
  reference_type_checkbox_info_text: 8528,
  checked_unchecked_must_be_different: 8532,
  range_from: 8531,
  range_to: 8530,
  uom_type_from: 8699,
  uom_type_to: 8700,
  conversion_factor: 8691,
  conversion_factors: 8696,
  add_conversion_factor: 8692,
  no_conversion_factors: 8804,
  choose: 8693,
  factor: 8610,
  uom_from: 8694,
  uom_to: 8695,
  remove: 8697,
  uom_conversion: 8702,
  uom_conversion_disclaimer_no_data: 8706,
  uom_conversion_disclaimer_choose_category: 8704,
  uom_conversion_disclaimer_not_supperted_uom_excluded: 8771,
  uom_type: 8703,
  uom_description: 9107,
  types_cannot_be_equal: 8795,
  residual_icon: 8801,
  recurrence_default_basic: 8802,
  potential_hazard_basic: 8803,
  likelihood_default_basic: 8969,
  reference_code_checkbox_disclaimer: 8820,
  deleted_code_validation: 9659,
  safety_limits: 9948,
  no_safety_limits: 9949,
  add_safety_limit: 9950,
  min_value: 9953,
  max_value: 9954,
  warning_deviation: 9951,
  min_max_value_error_message: 9952,

  // codetable item overlay
  saving_code: 8272,
  deleting_code: 8354,
  updated_successfully: 8273,
  saved_successfully: 8356,
  duplicated_successfully: 8451,

  // code picker
  search_required_message: 8146,
  no_options_found: 7644,
  search: 7345,
  done: 7338,

  // user group
  user_group: 8003,
  copy_from_user_group: 8681,
  create_empty_user_group: 8682,
  available_for_current_user_group: 8683,
  hierarchical_codetable_update: 8967,

  // risk matrix
  risk_matrix_configuration: 8985,
  risk_matrix_severity_reminder: 8986,
  risk_matrix_recurrence_frequency_reminder: 8987,
  risk_matrix_likelihood_reminder: 8988,
  risk_matrix: 8989,
  risk_matrix_add_reminder: 8992,
  risk_matrix_toast_reference: 9004,

  // duplicate hierarchy
  duplicate_hierarchy_title: 9343,
  duplicate_hierarchy_save_with: 9344,
  duplicate_hierarchy_save_without: 9345,
  duplicate_hierarchy_info: 9346,
  duplicate_hierarchy_copied_from: 9347,
  duplicate_hierarchy_hint: 9350,
  duplicate_hierarchy_option: 9351
};

export type CodetableTranslation = {
  readonly [T in keyof typeof codetableAdministrationTranslation]: string
};
